import { ClientLoadModel, LoadFindResultState } from '@numeo/types-core'
import { createSlice, PayloadAction } from '@reduxjs/toolkit'

// RTS Rating data interface
export interface RTSRatingData {
    rating: string
    name: string
    mcNumber: string
    averageDaysToPayPast60?: string
    city?: string
    state?: string
    lastActivity?: string
    lastCreditScoreChange?: string
    phone?: string
    email?: string
    dotNumber?: string
    address?: string
    collectionQueue?: string
    previousRating?: string
}

export interface LoadAssistantState {
    loadList: LoadFindResultState
    rtsRatings: Record<string, RTSRatingData> // Store RTS ratings by MC number
    newLoadsCounts: Record<string, number> // Track new loads count per truck
}

const initialState: LoadAssistantState = {
    loadList: {
        loads: {},
        shouldNotify: false,
        truckId: 'extension',
    },
    rtsRatings: {},
    newLoadsCounts: {},
}

const loadAssistantSlice = createSlice({
    name: 'loadAssistant',
    initialState,
    reducers: {
        setAssistantLoads(
            state,
            action: PayloadAction<{
                loads: Record<string, ClientLoadModel>
            }>
        ) {
            const { loads } = action.payload
            if (state.loadList.loads) {
                Object.assign(state.loadList.loads, loads)
            }
        },
        updateAssistantLoads(
            state,
            action: PayloadAction<{
                updatedLoads: Record<string, ClientLoadModel>
            }>
        ) {
            const { updatedLoads } = action.payload
            const currentResult = state.loadList

            if (currentResult) {
                const newLoads = { ...currentResult.loads }
                Object.entries(updatedLoads).forEach(([loadId, load]) => {
                    newLoads[loadId] = load
                })
                state.loadList.loads = newLoads
            }
        },
        setRTSRatingForAssistantLoad(
            state,
            action: PayloadAction<{
                mcNumber: string
                ratingData: RTSRatingData
            }>
        ) {
            const { mcNumber, ratingData } = action.payload
            state.rtsRatings[mcNumber] = ratingData
        },
        resetNewLoadsCount(state) {
            state.newLoadsCounts = {}
        },
    },
})

export const { setAssistantLoads, updateAssistantLoads, setRTSRatingForAssistantLoad, resetNewLoadsCount } = loadAssistantSlice.actions

export default loadAssistantSlice.reducer
